var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cv-toast-notification',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProductPrintable === false),expression:"isProductPrintable === false"}],attrs:{"title":_vm.$t('section.errors.product-not-printable-title'),"sub-title":`${_vm.$t('section.errors.product-not-printable-sub-title')} ${
    _vm.data.productName
  }`,"caption":_vm.$t('section.errors.product-not-printable-caption'),"kind":'error',"low-contrast":false,"hide-close-button":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }